module.exports = __webpack_public_path__ + "img/workshops.68f9f492.jpg";